import React, { useEffect } from "react"
import { connect } from "react-redux"

import {
  changeNotificationCount, changeNotificationList, changeNotificationMenu
} from "../store/actions"

import logo from '../assets/images/logo-sm.png'


import {
    apiRequest,
    notificationCheck,
    notificationCheckRapel
} from "../services/adapters/base"

let NotificationService = props => {
    useEffect(() => {
        // Defer execution by 3 seconds to ensure other API calls are fired first
        const timer = setTimeout(() => {
            checkNotification()
        }, 3000);
        return () => clearTimeout(timer);
    }, []);
  
    function showNotification(notif) {
    if(checkNotificationPromise()) {
        var options = {
            body: notif.notification_description,
            icon: logo
        };
        var notification = new Notification(notif.notification_title, options);
        notification.onclick = function() {
            window.open(window.location.origin.toString() + notif.notification_link, '_self');
            notification.close()
        };
    }
    }
    function checkNotificationPromise() {
        try {
            Notification.requestPermission().then();
        } catch(e) {
            return false;
        }
        return true;
    }
    async function checkNotificationRapel() {

        await apiRequest("get", notificationCheckRapel)
        .then(result => {
            if(result.status) {
                const response = result.response
                localStorage.setItem('list_notif_rapel', JSON.stringify(response.list_notif))
                //console.log('xxxx')
                //updateNotification(response.total, response.list, response.menu)
            }

            // setTimeout(function() {
            // }, 1000) // interval 60 
        })
    }
    async function checkNotification() {
      
        await apiRequest("get", notificationCheck)
        .then(result => {
            if(result.status) {
                const response = result.response
                console.log(response);
                if(response.flash.length > 0) {
                    response.flash.map((notif) => showNotification(notif))
                }
                localStorage.setItem('localTime', new Date().getTime())
                localStorage.setItem('serverTime', result.serverTime)
                updateNotification(response.total, response.list, response.menu)
            }

            setTimeout(function() {
            }, 120000) // interval 60 
        })
    }

    function updateNotification(total, list, menu) {
        props.changeNotificationCount(total)
        props.changeNotificationList(list)
        props.changeNotificationMenu(menu)
    }
    
    return (
        <></>
    )
}

const mapDispatchToProps = {
  changeNotificationCount: changeNotificationCount,
  changeNotificationList: changeNotificationList,
  changeNotificationMenu: changeNotificationMenu
};

NotificationService = connect(
  null,
  mapDispatchToProps,
)(NotificationService);

export default NotificationService